export default Object.freeze({
  CERT_REF_NO: 'certRefNo',
  DATE_OBTAINED: 'dateObtained',
  DATE_EXPIRY: 'dateExpiry',
  CUSTOM_FIELD_01: 'customField01',
  CUSTOM_FIELD_02: 'customField02',
  CUSTOM_FIELD_03: 'customField03',
  NOTE: 'note',
})
